import './Content.scss';
import Footer from './Footer';
import bank from './icons/bank.svg';
import coins from './icons/coins.svg';
import gavel from './icons/gavel.svg';
import money from './icons/money.svg';
import scales from './icons/scales.svg';
import { useEffect } from 'react';

const contentSections = [
    {
        id: 0,
        icon: gavel,
        title: "Civil Litigation",
        desc: "Dedicated and aggressive legal representation for both Plaintiffs and Defendants in all aspects of business, contract, and real estate disputes, ensuring thorough case analysis, strategic advocacy, and the pursuit of favorable outcomes through negotiation, litigation, or alternative dispute resolution methods.",
    },
    {
        id: 1,
        icon: scales,
        title: "Probate, Trust, and Elder Protection Litigation",
        desc: "Comprehensive services in trust management, estate administration, probate proceedings, and estate-related litigation, ensuring that your assets are properly handled, legal requirements are met, and any disputes are effectively resolved to protect your interests and those of your beneficiaries.",
    },
    {
        id: 2,
        icon: bank,
        title: "Business Planning",
        desc: "Expert guidance in counseling, formation, and organization of your business to help you establish a strong foundation, ensure compliance with legal requirements, and optimize operational efficiency for long-term success.",
    },
    {
        id: 3,
        icon: money,
        title: "Business Purchase and Sale, Mergers, and Acquisitions",
        desc: "Providing expert legal guidance in business purchases and sales, mergers, and acquisitions, ensuring seamless transactions, thorough due diligence, risk mitigation, and strategic structuring to protect clients’ interests and maximize value.",
    },
    {
        id: 4,
        icon: coins,
        title: "Estate Planning and Wealth/Asset Protection",
        desc: "Comprehensive and strategic estate planning services designed to safeguard your family's future, ensure the continuity and success of your business, and preserve your legacy for generations to come.",
    },
    // {
    //     id: 5,
    //     personal: true,
    //     desc: "Ryan is admitted to practice before all the state courts of California, as well as the Southern and Central United States District Courts and the Ninth Circuit Court of Appeals. He lives in the City of Orange with his wife, Carrie, and son, Nate.",
    // },
]

function Content (props: {isMobile: boolean}) {
    useEffect(() => {
        window.addEventListener("scroll", (event) => {
            let scroll = window.scrollY;
            const el = document.getElementById('contact');
            if (scroll >= 400) {
                el?.classList.add('show')
            } else {
                el?.classList.remove('show')
            }
        });
    }, [])

    return <section className="site-content">
        {/* <div className='contact' id="contact">
            <p className='connection'>Let's Connect</p>
            {props.isMobile ? 
                    (<a className="phone-link" href='tel:+1714-835-3837'>(714) 835-3837</a>) : 
                    (<p className="phone">(714) 835-3837</p>)
                }
                <a href="mailto:englishlawcorp@gmail.com" className="email">Email</a>
            </div> */}
        <div className="about-and-services">
            <section className="about-container main-section">
                <div className="image"></div>
                <div className="text-container">
                    <h2>Meet Ryan</h2>
                    <p className="text">Licensed in 2002, Ryan English has over twenty years of experience as an attorney. He obtained an undergraduate degree (BA) in Law and Society with a minor in Psychological Science from the University of California, Irvine, and earned his Juris Doctorate from Whittier Law School. <br></br><br></br>Ryan is admitted to practice before all the state courts of California, as well as the Southern and Central United States District Courts and the Ninth Circuit Court of Appeals. He lives in the City of Orange with his wife, Carrie, and son, Nate.</p>
                </div>
            </section>
            <h2 className="specialties">Practice Areas</h2>
            <section className="services">
                { contentSections.map((c) =><>
                    <section key={c.id} className="main-section">
                        <div className="content-section">
                            <span className="header">
                                <img src={c?.icon} />
                                <p className="title">{c?.title}</p>
                            </span>
                            <p className={`desc`}>{c.desc}</p>
                            {/* <p className={`desc ${c.personal && 'personal'}`}>{c.desc}</p> */}
                        </div>
                    </section></>
                )}
            </section>
        </div>
        <Footer />
    </section>
}

export default Content;